import React, { useState, useEffect } from 'react';
import pb from '../../../lib/pocketbase';

const History = ({ user }) => {
    const [vehicles, setVehicles] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAddForm, setShowAddForm] = useState(false);
    const [newVehicle, setNewVehicle] = useState({
        brand: '',
        model: '',
        plate: '',
        year: '',
        fuel: 'Essence'
    });

    const fetchVehicles = async () => {
        setLoading(true);
        try {
            const records = await pb.collection('vehicles').getFullList({
                filter: `users = "${user.id}"`,
                sort: '-created',
            });
            setVehicles(records);
        } catch (err) {
            console.error('Erreur véhicules:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (user?.id) {
            fetchVehicles();
        }
    }, [user?.id]);

    const handleAddVehicle = async (e) => {
        e.preventDefault();
        try {
            await pb.collection('vehicles').create({
                ...newVehicle,
                users: user.id,
                year: Number(newVehicle.year)
            });
            setShowAddForm(false);
            setNewVehicle({ brand: '', model: '', plate: '', year: '', fuel: 'Essence' });
            fetchVehicles(); // Refresh list
        } catch (err) {
            alert('Erreur lors de l\'ajout du véhicule : ' + err.message);
        }
    };

    if (loading && vehicles.length === 0) return <div className="account-content-wrapper">Chargement de vos véhicules...</div>;
    if (!user) return <div className="account-content-wrapper">Veuillez vous connecter.</div>;

    return (
        <div className="account-content-wrapper">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '3rem', borderBottom: '1px solid rgba(148, 163, 184, 0.1)', paddingBottom: '2rem' }}>
                <div>
                    <h2 style={{ fontSize: '2.4rem', margin: 0, color: '#f8fafc', fontWeight: 800, letterSpacing: '-0.02em' }}>Mon Garage</h2>
                    <p style={{ margin: '0.5rem 0 0', color: '#94a3b8', fontSize: '1.1rem' }}>Gérez vos véhicules et accédez à leur historique de maintenance.</p>
                </div>
                <button
                    className="primary-button"
                    style={{
                        padding: '0.6rem 1.25rem',
                        borderRadius: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.6rem',
                        fontSize: '0.9rem',
                        fontWeight: 700,
                        width: 'auto',
                        margin: 0,
                        height: 'fit-content'
                    }}
                    onClick={() => setShowAddForm(true)}
                >
                    <span style={{ fontSize: '1.4rem', lineHeight: 0.8 }}>+</span> Ajouter un véhicule
                </button>
            </div>

            {showAddForm && (
                <div className="modal-backdrop" onClick={() => setShowAddForm(false)}>
                    <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '500px' }}>
                        <div className="modal-header-flex">
                            <h3>Ajouter un véhicule</h3>
                            <button className="modal-close" onClick={() => setShowAddForm(false)}>×</button>
                        </div>
                        <form onSubmit={handleAddVehicle} className="settings-form">
                            <div className="form-group">
                                <label>Marque</label>
                                <input
                                    type="text"
                                    className="admin-input"
                                    placeholder="Ex: BMW"
                                    required
                                    value={newVehicle.brand}
                                    onChange={e => setNewVehicle({ ...newVehicle, brand: e.target.value })}
                                />
                            </div>
                            <div className="form-group">
                                <label>Modèle</label>
                                <input
                                    type="text"
                                    className="admin-input"
                                    placeholder="Ex: Série 3"
                                    required
                                    value={newVehicle.model}
                                    onChange={e => setNewVehicle({ ...newVehicle, model: e.target.value })}
                                />
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                                <div className="form-group">
                                    <label>Plaque</label>
                                    <input
                                        type="text"
                                        className="admin-input"
                                        placeholder="AA-123-BB"
                                        required
                                        value={newVehicle.plate}
                                        onChange={e => setNewVehicle({ ...newVehicle, plate: e.target.value })}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Année</label>
                                    <input
                                        type="number"
                                        className="admin-input"
                                        placeholder="2020"
                                        required
                                        value={newVehicle.year}
                                        onChange={e => setNewVehicle({ ...newVehicle, year: e.target.value })}
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Carburant</label>
                                <select
                                    className="admin-input"
                                    value={newVehicle.fuel}
                                    onChange={e => setNewVehicle({ ...newVehicle, fuel: e.target.value })}
                                >
                                    <option value="Essence">Essence</option>
                                    <option value="Diesel">Diesel</option>
                                    <option value="Hybride">Hybride</option>
                                    <option value="Électrique">Électrique</option>
                                </select>
                            </div>
                            <button type="submit" className="primary-button full-width" style={{ marginTop: '1rem' }}>
                                Enregistrer le véhicule
                            </button>
                        </form>
                    </div>
                </div>
            )}

            <div className="dashboard-grid-account" style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
                gap: '2.5rem'
            }}>
                {vehicles.length > 0 ? vehicles.map(v => (
                    <div key={v.id} className="vehicle-card-premium" style={{
                        padding: '2.5rem',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '1.5rem',
                        position: 'relative',
                        overflow: 'hidden',
                        background: 'rgba(30, 41, 59, 0.4)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(148, 163, 184, 0.1)',
                        borderRadius: '1.8rem',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{
                                width: '56px',
                                height: '56px',
                                background: 'linear-gradient(135deg, rgba(250, 204, 21, 0.2), rgba(250, 204, 21, 0.05))',
                                borderRadius: '16px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '1.8rem',
                                boxShadow: 'inset 0 0 10px rgba(250, 204, 21, 0.1)'
                            }}>
                                🚗
                            </div>
                            <span className="plate-badge" style={{
                                background: 'rgba(250, 204, 21, 0.08)',
                                border: '1px solid rgba(250, 204, 21, 0.3)',
                                color: '#facc15',
                                padding: '0.4rem 1rem',
                                borderRadius: '8px',
                                fontSize: '0.8rem',
                                fontWeight: 800,
                                letterSpacing: '0.1em'
                            }}>
                                {v.plate}
                            </span>
                        </div>

                        <div>
                            <h3 style={{ margin: 0, fontSize: '1.6rem', color: '#f8fafc', fontWeight: 800, letterSpacing: '-0.02em' }}>{v.brand}</h3>
                            <p style={{ margin: '0.2rem 0 0', color: '#facc15', fontSize: '1.1rem', fontWeight: 600 }}>{v.model}</p>
                            <p style={{ margin: '0.75rem 0 0', color: '#64748b', fontSize: '0.7rem', fontFamily: 'monospace', opacity: 0.8 }}>ID: {v.id}</p>
                        </div>

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '1.5rem',
                            borderTop: '1px solid rgba(148, 163, 184, 0.1)',
                            borderBottom: '1px solid rgba(148, 163, 184, 0.1)',
                            padding: '1.5rem 0',
                            marginTop: '0.5rem'
                        }}>
                            <div>
                                <span style={{ display: 'block', fontSize: '0.7rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '0.45rem', fontWeight: 700 }}>Année :</span>
                                <span style={{ fontSize: '1.1rem', color: '#f1f5f9', fontWeight: 700 }}>{v.year}</span>
                            </div>
                            <div>
                                <span style={{ display: 'block', fontSize: '0.7rem', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '0.45rem', fontWeight: 700 }}>Énergie :</span>
                                <span style={{ fontSize: '1.1rem', color: '#f1f5f9', fontWeight: 700 }}>{v.fuel}</span>
                            </div>
                        </div>

                        <button className="premium-btn" style={{
                            width: '100%',
                            marginTop: '0.5rem',
                            padding: '1rem',
                            borderRadius: '12px',
                            background: 'transparent',
                            color: '#94a3b8',
                            border: '1px solid rgba(148, 163, 184, 0.2)',
                            fontSize: '0.9rem',
                            fontWeight: 600,
                            cursor: 'pointer',
                            transition: 'all 0.3s'
                        }}>
                            Voir l&apos;historique d&apos;entretien
                        </button>
                    </div>
                )) : (
                    <div className="card" style={{ padding: '5rem 2rem', textAlign: 'center', borderStyle: 'dashed', opacity: 0.7, gridColumn: '1 / -1', background: 'rgba(15, 23, 42, 0.2)', borderRadius: '2rem', border: '2px dashed rgba(148, 163, 184, 0.1)' }}>
                        <div style={{ fontSize: '4rem', marginBottom: '1.5rem' }}>🏎️</div>
                        <h3 style={{ fontSize: '1.8rem', marginBottom: '0.75rem', color: '#f8fafc' }}>Votre garage est vide</h3>
                        <p style={{ color: '#94a3b8', maxWidth: '450px', margin: '0 auto 2.5rem', fontSize: '1.1rem', lineHeight: '1.6' }}>Enregistrez vos véhicules pour un suivi simplifié et des devis plus rapides lors de vos prochaines visites.</p>
                        <button
                            className="primary-button"
                            style={{ padding: '1rem 2.5rem', borderRadius: '15px' }}
                            onClick={() => setShowAddForm(true)}
                        >
                            Enregistrer mon premier véhicule
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default History;

